module.exports = "/img/act.4169069d.png";